import * as React from 'react'

import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Icon from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

import { ResourceTypes, ResourcesCount } from 'types/types'
import { mapIcon } from 'utils/resources'

const Item = styled(Stack)`
    padding: 1rem;
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`

interface ResourcesGridProps {
    resourcesCount: ResourcesCount
}

const ResourcesGrid = ({ resourcesCount }: ResourcesGridProps) => {
    const { t }: I18n = useTranslation()

    return (
        <Stack gap="1rem">
            <Text variant="h4">{t('path:resourcesSection.title')}</Text>
            <Text color="text.secondary">{t('path:resourcesSection.description')}</Text>
            <Grid container spacing={2} mt={1}>
                {Object.entries(resourcesCount)
                    .filter(([key, value]) => value > 0 && key !== 'total')
                    .map(([key, value]) => {
                        return (
                            <Grid item xs={6} sm={4} md={2} key={key}>
                                <Item key={key} gap="1rem" justifyContent="center" alignItems="center">
                                    <Icon name={mapIcon(key as ResourceTypes)} />
                                    <Text variant="body2" fontWeight={800}>{`${value} ${
                                        value > 1
                                            ? t(`resources:types.plurals.${key.toUpperCase()}`)
                                            : t(`resources:types.${key.toUpperCase()}`)
                                    }`}</Text>
                                </Item>
                            </Grid>
                        )
                    })}
            </Grid>
        </Stack>
    )
}

export default ResourcesGrid
